import { render, staticRenderFns } from "./RecordCard.vue?vue&type=template&id=54d6fb90&scoped=true&"
import script from "./RecordCard.vue?vue&type=script&lang=js&"
export * from "./RecordCard.vue?vue&type=script&lang=js&"
import style0 from "./RecordCard.vue?vue&type=style&index=0&id=54d6fb90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d6fb90",
  null
  
)

export default component.exports